import { interactionResponse } from '@zillow/yield-callback';

import { runWhenIdle } from '@/src/lib/utils/runWhenIdle';

const CONFETTI_IDLE_TIMEOUT_MS = 200;

async function triggerFavoriteConfettiWhenReady(button: HTMLButtonElement): Promise<void> {
  try {
    const { triggerFavoriteConfetti } = await import('./favoriteConfetti');
    if (!button.isConnected) return;
    const rect = button.getBoundingClientRect();
    triggerFavoriteConfetti({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    });
  } catch {
    return;
  }
}

async function scheduleAfterInteraction(button: HTMLButtonElement): Promise<void> {
  try {
    await interactionResponse();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    runWhenIdle(
      () => {
        if (!button.isConnected) return;
        void triggerFavoriteConfettiWhenReady(button);
      },
      { timeoutMs: CONFETTI_IDLE_TIMEOUT_MS, fallbackDelayMs: 0 },
    );
  } catch {
    return;
  }
}

export function scheduleFavoriteConfetti(button: HTMLButtonElement): void {
  void scheduleAfterInteraction(button);
}
